<div *ngIf="showHeader" class="position-relative rentree">
    <a class="container-fluid d-block" href="https://tally.so/r/mRPzQ4?utm_source=app" target="_blank">
        <div class="row">
            <p class="text-white col-12 text-center mb-1">
                LyBox lance son service d'investissement locatif clés en mains ! <u>Cliquez ici pour en savoir plus</u>
            </p>
        </div>
    </a>
    <img src="assets/close.png" alt="close" (click)="closeTopMsg()"/>
</div>

<app-header [ngClass]="{'top_msg': showHeader}"></app-header>
<div
    class="wrapper {{ authenticationService.currentUser.code_parrainage }} {{authenticationService.currentUser.pro_plan}}">
    <!-- Sidebar  -->
    <app-sidebar [ngClass]="{'collapsed' : authenticationService.currentUser.user_dashboard.sidebar_collapse, 'top_msg': showHeader}"></app-sidebar>

    <!-- Page Content  -->
    <div id="content" [ngClass]="{
        'container-fluid': true, 'extended' : authenticationService.currentUser.user_dashboard.sidebar_collapse,
        'top_msg':showHeader}">
        <app-alert></app-alert>
        <router-outlet></router-outlet>

        <div id="saved">
            <i class="fa fa-check"></i>
        </div>
        <div id="typing">
            <img src="assets/typing.gif">
        </div>
    </div>
</div>

<div *ngIf="this.onboardingService.isOnboardingActivate()"
     [ngClass]="{'onboarding hide-mobile': true, 'SEBMORE': authenticationService.currentUser.code_parrainage == 'SEBMORE', 'close': this.authenticationService.currentUser.user_onboarding.open == false}">
    <div class="title fs-3">
        Les étapes pour démarrer avec LyBox
        <i class="fa fa-chevron-down" *ngIf="this.authenticationService.currentUser.user_onboarding.open == true"
           (click)="trackingService.click('sidebar_open_onboarding','');toogleOnboarding()"></i>
        <i class="fa fa-chevron-up" *ngIf="this.authenticationService.currentUser.user_onboarding.open == false"
           (click)="trackingService.click('sidebar_close_onboarding','');toogleOnboarding()"></i>
        <span *ngIf="this.authenticationService.currentUser.user_onboarding.open == false"
              (click)="trackingService.click('sidebar_end_onboarding','');closeOnboarding()">
            Terminer la visite guidée
        </span>
    </div>
    <ul>
        <li class="text-stroke">
            <i class="fa fa-check-circle me-2 text-green"
               aria-hidden="true"></i>
            <span>Créer son compte</span>
        </li>
        <li [ngClass]="{'hover': true, 'text-stroke': user.user_onboarding.search.status == 'done'}"
            (click)="trackingService.click('sidebar_start_onboarding_search',user.user_onboarding.search.status);onboardingService.startSearch().subscribe()">
            <i *ngIf="user.user_onboarding.search.status == 'not_started'"
               class="fa fa-check-circle text-light" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.search.status == 'done'" class="fa fa-check-circle text-green"
               aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.search.status == 'in_progress'"
               class="fa text-progress fa-pause-circle text-green"
               aria-hidden="true"></i>

            <span>Faire une recherche</span>
            <i *ngIf="user.user_onboarding.search.status == 'done'" class="fa fa-refresh" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.search.status != 'done'" class="fa fa-play text-light"
               aria-hidden="true"></i>
        </li>
        <li [ngClass]="{'hover': true, 'text-stroke': user.user_onboarding.annonce.status == 'done'}"
            (click)="trackingService.click('sidebar_start_onboarding_annonce',user.user_onboarding.annonce.status);openAnnonce()">
            <i *ngIf="user.user_onboarding.annonce.status == 'not_started'"
               class="fa fa-check-circle text-light" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.annonce.status == 'done'" class="fa fa-check-circle text-green"
               aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.annonce.status == 'in_progress'"
               class="fa text-progress fa-pause-circle text-green"
               aria-hidden="true"></i>
            <span>Analyser une annonce</span>
            <i *ngIf="user.user_onboarding.annonce.status == 'done'" class="fa fa-refresh" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.annonce.status != 'done'" class="fa fa-play text-light"
               aria-hidden="true"></i>
        </li>


        <li  *ngIf="user.user_onboarding.search.status == 'done' &&
                    user.user_onboarding.annonce.status == 'done'"
            [ngClass]="{'hover': true, 'text-stroke': user.user_onboarding.alert.status == 'done'}"
            (click)="trackingService.click('sidebar_start_onboarding_alert',user.user_onboarding.alert.status);openAlert()">
            <i *ngIf="user.user_onboarding.alert.status == 'not_started'"
               class="fa fa-check-circle text-light" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.alert.status == 'done'" class="fa fa-check-circle text-green"
               aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.alert.status == 'in_progress'"
               class="fa text-progress fa-pause-circle text-green"
               aria-hidden="true"></i>
            <span>Créer une alerte mail</span>
            <i *ngIf="user.user_onboarding.alert.status == 'done'" class="fa fa-refresh" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.alert.status != 'done'" class="fa fa-play text-light" aria-hidden="true"></i>
        </li>
        <li  *ngIf="user.user_onboarding.search.status == 'done' &&
                    user.user_onboarding.annonce.status == 'done'"
             [ngClass]="{'hover': true, 'text-stroke': user.user_onboarding.favoris_list.status == 'done'}"
             (click)="trackingService.click('sidebar_start_onboarding_favorite_list',user.user_onboarding.favoris_list.status);openFavoriteList()">
            <i *ngIf="user.user_onboarding.favoris_list.status == 'not_started'"
               class="fa fa-check-circle text-light" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.favoris_list.status == 'done'" class="fa fa-check-circle text-green"
               aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.favoris_list.status == 'in_progress'"
               class="fa text-progress fa-pause-circle text-green"
               aria-hidden="true"></i>
            <span>Organiser mes favoris</span>
            <i *ngIf="user.user_onboarding.favoris_list.status == 'done'" class="fa fa-refresh" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.favoris_list.status != 'done'" class="fa fa-play text-light"
               aria-hidden="true"></i>
        </li>


        <li  *ngIf="user.user_onboarding.search.status == 'done' &&
                    user.user_onboarding.annonce.status == 'done' &&
                    user.user_onboarding.show_list_search == true &&
                    user.user_onboarding.favoris_list.status == 'done'"
             [ngClass]="{'hover': true, 'text-stroke': user.user_onboarding.ville.status == 'done'}"
             (click)="trackingService.click('sidebar_start_onboarding_ville',user.user_onboarding.ville.status);onboardingService.startVille().subscribe()">
            <i *ngIf="user.user_onboarding.ville.status == 'not_started'"
               class="fa fa-check-circle text-light" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.ville.status == 'done'" class="fa fa-check-circle text-green"
               aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.ville.status == 'in_progress'"
               class="fa text-progress fa-pause-circle text-green"
               aria-hidden="true"></i>
            <span>Trouver les villes rentables</span>
            <i *ngIf="user.user_onboarding.ville.status == 'done'" class="fa fa-refresh" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.ville.status != 'done'" class="fa fa-play text-light" aria-hidden="true"></i>
        </li>

        <li  *ngIf="user.user_onboarding.search.status == 'done' &&
                    user.user_onboarding.annonce.status == 'done' &&
                    user.user_onboarding.show_list_search == true &&
                    user.user_onboarding.favoris_list.status == 'done' &&
                    user.user_onboarding.ville.status == 'done'"
             [ngClass]="{'hover': true, 'text-stroke': user.user_onboarding.pdf.status == 'done'}"
            (click)="trackingService.click('sidebar_start_onboarding_pdf',user.user_onboarding.pdf.status);openPDF()">
            <i *ngIf="user.user_onboarding.pdf.status == 'not_started'"
               class="fa fa-check-circle text-light" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.pdf.status == 'done'" class="fa fa-check-circle text-green"
               aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.pdf.status == 'in_progress'"
               class="fa text-progress fa-pause-circle text-green"
               aria-hidden="true"></i>
            <span>Exporter un rapport PDF</span>
            <i *ngIf="user.user_onboarding.pdf.status == 'done'" class="fa fa-refresh" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.pdf.status != 'done'" class="fa fa-play text-light" aria-hidden="true"></i>
        </li>
        <li  *ngIf="user.user_onboarding.search.status == 'done' &&
                    user.user_onboarding.annonce.status == 'done' &&
                    user.user_onboarding.show_list_search == true &&
                    user.user_onboarding.favoris_list.status == 'done' &&
                    user.user_onboarding.ville.status == 'done'"
             [ngClass]="{'hover': true, 'text-stroke': user.user_onboarding.compare.status == 'done'}"
            (click)="trackingService.click('sidebar_start_onboarding_compare',user.user_onboarding.compare.status);compare()">
            <i *ngIf="user.user_onboarding.compare.status == 'not_started'"
               class="fa fa-check-circle text-light" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.compare.status == 'done'" class="fa fa-check-circle text-green"
               aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.compare.status == 'in_progress'"
               class="fa text-progress fa-pause-circle text-green"
               aria-hidden="true"></i>
            <span>Comparer plusieurs projets</span>
            <i *ngIf="user.user_onboarding.compare.status == 'done'" class="fa fa-refresh" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.compare.status != 'done'" class="fa fa-play text-light"
               aria-hidden="true"></i>
        </li>
        <li  *ngIf="user.user_onboarding.search.status == 'done' &&
                    user.user_onboarding.annonce.status == 'done' &&
                    user.user_onboarding.show_list_search == true &&
                    user.user_onboarding.favoris_list.status == 'done' &&
                    user.user_onboarding.ville.status == 'done'"
             [ngClass]="{'hover': true, 'text-stroke': user.user_onboarding.parameters.status == 'done'}"
            (click)="trackingService.click('sidebar_start_onboarding_params',user.user_onboarding.parameters.status);onboardingService.startParams().subscribe()">
            <i *ngIf="user.user_onboarding.parameters.status == 'not_started'"
               class="fa fa-check-circle text-light" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.parameters.status == 'done'" class="fa fa-check-circle text-green"
               aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.parameters.status == 'in_progress'"
               class="fa text-progress fa-pause-circle text-green"
               aria-hidden="true"></i>
            <span>Modifier mes préférences</span>
            <i *ngIf="user.user_onboarding.parameters.status == 'done'" class="fa fa-refresh" aria-hidden="true"></i>
            <i *ngIf="user.user_onboarding.parameters.status != 'done'" class="fa fa-play text-light"
               aria-hidden="true"></i>
        </li>
    </ul>
</div>

<!-- Onboarding -->
<joyrideStep [stepContent]="endStep1Content"
             joyrideStep="endStep1"
             stepPosition="center">
</joyrideStep>
<ng-template #endStep1Content>
    <div class="fs-6 user_onboarding_author">
        <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle"/><b>Thomas</b> de LyBox<br/>
    </div>
    <div class="user_onboarding_content">
        <iframe width="800" height="450" src="https://www.youtube.com/embed/9_S7upBQuHM?autoplay=1" title="Vous avez découvert les premières fonctionnalités de LyBox" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
</ng-template>

<joyrideStep [stepContent]="endStep2Content"
             joyrideStep="endStep2"
             stepPosition="center">
</joyrideStep>
<ng-template #endStep2Content>
    <div class="fs-6 user_onboarding_author">
        <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle"/><b>Thomas</b> de LyBox<br/>
    </div>
    <div class="user_onboarding_content">
        <iframe width="800" height="450" src="https://www.youtube.com/embed/gGvT9tvugWc?autoplay=1" title="Bravo ! Vous avez découvert les principales fonctionnalités de LyBox !" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
</ng-template>

<joyrideStep [stepContent]="endStep3Content"
             joyrideStep="endStep3"
             stepPosition="center">
</joyrideStep>
<ng-template #endStep3Content>
    <div class="fs-6 user_onboarding_author">
        <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle"/><b>Thomas</b> de LyBox<br/>
    </div>
    <div class="user_onboarding_content">
        <iframe width="800" height="450" src="https://www.youtube.com/embed/7uCBI57yjaE?autoplay=1" title="Félicitations, vous êtes un expert de LyBox !" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
</ng-template>


<joyrideStep [stepContent]="endStepContent"
             joyrideStep="endStep"
             stepPosition="center">
</joyrideStep>
<ng-template #endStepContent>
    <div class="fs-6 user_onboarding_author">
        <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle"/><b>Thomas</b> de LyBox<br/>
    </div>
    <img src="assets/bravo.gif" class="user_onboarding_visuel gif"/>
    <div class="p-2 user_onboarding_content">
        <p>
            Félicitations, vous êtes maintenant un expert de l’application LyBox !<br/>
            <br/>
            Maintenant, plus rien ne peut vous arrêter pour faire vos meilleurs investissements locatifs 😃<br/>
            <br/>
            Si vous avez la moindre question, nous sommes disponibles via le chat en bas à droite de la page.<br/>
            <br/>
            Pour choisir l’abonnement qui vous correspond, vous pouvez vous rendre sur <a
            href="https://www.lybox.fr/app/user/plan">https://www.lybox.fr/app/user/plan</a><br/>
            <br/>
            Je vous souhaite de très bons investissements !<br/>
        </p>
    </div>
</ng-template>

<joyrideStep [stepContent]="noAnnoncesStepContent"
             joyrideStep="noAnnoncesStep"
             stepPosition="center">
</joyrideStep>
<ng-template #noAnnoncesStepContent>
    <div class="user_onboarding_content">
        <h2>Oups, vous allez un peu vite !</h2>
        <p>
            Pour pouvoir analyser une annonce, vous devez d’abord avoir terminé les étapes suivantes :
        </p>
        <ul>
            <li>Faire une recherche</li>
            <li>Ouvrir une annonce</li>
        </ul>
        <p>
            On se retrouve tout de suite 😉

        </p>
    </div>
</ng-template>

<joyrideStep [stepContent]="noFavoriteStepContent"
             joyrideStep="noFavoriteStep"
             stepPosition="center">
</joyrideStep>
<ng-template #noFavoriteStepContent>
    <div class="user_onboarding_content">
        <h2>Oups, vous allez un peu vite !</h2>
        <p>
            Pour pouvoir exporter, vous devez d’abord avoir terminé les étapes suivantes :
        </p>
        <ul>
            <li>Faire une recherche</li>
            <li>Ouvrir une annonce</li>
            <li>Enregistrer l'annonce en favoris</li>
        </ul>
        <p>
            On se retrouve tout de suite 😉

        </p>
    </div>
</ng-template>

<joyrideStep [stepContent]="noSearchStepContent"
             joyrideStep="noSearchStep"
             stepPosition="center">
</joyrideStep>
<ng-template #noSearchStepContent>
    <div class="user_onboarding_content">
        <h2>Oups, vous allez un peu vite !</h2>
        <p>
            Pour pouvoir créer une alerte mail, vous devez d’abord avoir terminé les étapes suivantes :
        </p>
        <ul>
            <li>Faire une recherche</li>
            <li>Enregistrer une recherche</li>
        </ul>
        <p>
            On se retrouve tout de suite 😉

        </p>
    </div>
</ng-template>
